import WbHttpClient from './../../services/wbhttpclient';

export default class BoardService extends WbHttpClient
{

    public saveColumn(params = {}) {
        return this.post('board/saveBoardColumn', params);
    }

    public deleteColumn(params = {}) {
        return this.post('board/deleteBoardColumn', params);
    }

    public saveColumnSorting(params = {}) {
        return this.post('board/saveColumnSorting', params);
    }

    public saveCustomSortingOrder(params = {}) {
        return this.post('board/saveCustomSortingOrder', params);
    }

    public saveUserWsFtSortingOrder(params = {}) {
        return this.post('board/saveUserWsFtSortingOrder', params);
    }

    public changeColumn(params = {}) {
        return this.post('board/changeColumn', params);
    }

    public saveAIState(params = {}) {
        return this.post('activity/state_act', params);
    }

    public createAI(params = {}) {
        return this.post('activity/create', params);
    }

    public searchBoardTag(params = {}) {
        const p = Object.assign({source: 'board'}, params);
        return this.get('activity/findTags', p)
    }

    public saveBoardFilters(params = {}) {
        return this.post('board/saveBoardFilters', params);
    }

    public updateAiDates(params = {}) {
        return this.post('activity/updateAIDates', params);
    }

    public fireWsTimelineEvent(params = {}) {
        return this.post('board/fireWsTimelineEvent', params);
    }

    public getWsDetails(params = {}) {
        return this.post('activity/getWorkStreamDetailsWsId', params);
    }

    public getBoardMenu(params = {}) {
        return this.post('board/getBoardTopMenuDetails', params);
    }

    public removeBoard(params = {}) {
        return this.post('board/leaveBoard', params);
    }

    public deleteBoard(params = {}) {
        return this.post('board/deleteBoardEvent', params);
    }

    public saveBoardPreference(params = {}) {
        return this.post('board/savePreference', params);
    }

    public deleteBoardCard(params = {}) {
        return this.post('board/deleteObjectInColumn', params);
    }

    public getAiDataForBoard(params = {}) {
        return this.get('board/getAiDataForBoard', params);
    }

    public getWorkstreamData() {
        return this.get('board/getWorkstreamData');
    }

    public getUserTeamData() {
        return this.get('board/getBoardUserTeamList');
    }

    public saveBoardWs(params = {}) {
        return this.post('board/saveBoardWs', params)
    }

    public saveBoardPeople(params = {}) {
        return this.post('board/saveBoardPeople', params);
    }

    public getAutomationData(params = {}) {
        return this.get('board/getAutomationData', params);
    }

    public getAssigneeList(params = {}) {
        return this.get('board/viewAssigniList', params);
    }

    public saveColAutomationWsData(params = {}) {
        return this.post('board/saveColAutomationWsData', params)
    }

    public saveColAutomationPeopleData(params = {}) {
        return this.post('board/saveColAutomationPeopleData', params);
    }

    public getBoardWsLists(params = {}) {
        return this.get('board/getWsList', params);
    }

    public getTeamMembersForAiAutomation(params={}){
        return this.get('team/getTeamMembersForAiAutomation',params);
    }

    public getOrgUsers(params = {}) {
        return this.get('activity/getOrgUsers', params);
    }

    public saveColAutomationAiData(params ={}){
        return this.post('board/saveColAutomationAiData',params);
    }

    public getTagCount(params = {}) {
        return this.get('board/getTagCount', params);
    }

    public updateAiOwner(params = {}) {
        return this.post('activity/UpdateAssigni', params);
    }

    public updateAiType(id: number | string, type: number) {
        return this.post('activity/updateType', { actId: id, type });
    }

    public getAiLoopMembers(params = {}) {
        return this.get('board/getAiLoopMembers', params);
    }

    public getWsGraphData(params = {}) {
        return this.get('activity/getWsGraphData', params);
    }

    public getRelationshipsCount(params: {ids: string[]}) {
        return this.get('pmActionItemRelationship/relationshipsGetCountsByActionItemIds', params);
    }
}